import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import PageTitle from '@/components/v2/PageTitle.vue';
import ActionButton from '@/components/action_button/Index.vue';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import AppBundle from '@/plugins/graphql/queries/v2/app-bundle.gql';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
import ButtonLoaderMixin from '@/helpers/vue_mixins/ButtonLoaderMixin';
import GraphqlErrorMixin from '@/helpers/vue_mixins/GraphqlErrorMixin';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import AppBasicDetails from '@/components/v2/AppBasicDetails';
import BaseOverlayLoader from '@/components/v2/BaseOverlayLoader';
import CleverTapEventsMixin from '@/helpers/vue_mixins/v3/CleverTapEventsMixin';
import ConfirmationDialog from '@/components/BaseConfirmDialog.vue';
import StoreAnnouncementBannerManager from '@/components/v2/StoreAnnouncementBannerManager.vue';
import Draggable from 'vuedraggable';
let StoreAnnouncementBanners = class StoreAnnouncementBanners extends Mixins(ViewportSizeMixin, AlertMixin, ButtonLoaderMixin, GraphqlErrorMixin, Mixins(RouterParamsAppMixin, CleverTapEventsMixin)) {
    constructor() {
        super(...arguments);
        this.toggleConfirm = false;
    }
    get headers() {
        return [
            {
                text: 'ID',
                value: 'id',
                align: 'left',
                sortable: false,
            },
            {
                text: 'BANNER CONTENT',
                value: 'text',
                align: 'left',
                sortable: false,
            },
            {
                text: 'DURATION',
                value: 'duration',
                align: 'left',
                sortable: false,
            },
            {
                text: 'STATUS',
                value: 'status',
                align: 'left',
                sortable: false,
                switchable: true,
            },
            {
                text: '',
                value: '',
                align: '',
                sortable: false,
            },
        ];
    }
    stripHtml(html) {
        if (!html)
            return '';
        const textWithNewlines = html.replace(/<\/p>/gi, '\n').replace(/<p[^>]*>/gi, '');
        const cleanText = textWithNewlines.replace(/<[^>]*>/g, '');
        return cleanText.trim();
    }
    buttonLabel() {
        return this.$vuetify.breakpoint.smAndUp ? 'Create Announcement' : 'Create';
    }
    goBack() {
        this.$router.push({
            name: 'ecommerce-overview',
            params: { uuid: this.appUUID, to: 'ecommerce-overview' },
        });
    }
    toggleConfirmation() {
        this.toggleConfirm = true;
    }
};
StoreAnnouncementBanners = __decorate([
    Component({
        components: {
            PageTitle,
            StoreAnnouncementBannerManager,
            ActionButton,
            AppBasicDetails,
            BaseOverlayLoader,
            ConfirmationDialog,
            Draggable,
        },
        apollo: {
            appBundle: {
                query: AppBundle,
                variables() {
                    return { appUuid: this.appUUID };
                },
                update(data) {
                    return data.appServiceBundle.name;
                },
            },
        },
    })
], StoreAnnouncementBanners);
export default StoreAnnouncementBanners;
